



<template>
 
 <v-row>
     <v-checkbox
            class="ma-5"
              v-model="isChecked"
              label="is the update critic ?"
              color="red darken-3"
              hide-details
              @change="selectionChange()"
            ></v-checkbox>
    <v-btn @click="send" class="ma-5">
        Send appupdate
	</v-btn>

 </v-row>


     
</template>


<script>



export default {

    

    data: ()=>({

        isChecked:false,
        dataToSend:null

    }),
    methods:{
        selectionChange: function (){
            this.dataToSend = this.isChecked

        },
        send:function(){
            this.$emit('sendAppUpdate',this.dataToSend);
        }
    }

}
</script>